import { render, staticRenderFns } from "./MXSidebar.vue?vue&type=template&id=423208ec&scoped=true"
import script from "./MXSidebar.vue?vue&type=script&lang=js"
export * from "./MXSidebar.vue?vue&type=script&lang=js"
import "./MXSidebar.vue?vue&type=style&index=0&id=423208ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423208ec",
  null
  
)

export default component.exports